











































import RespondecoMenu from './menu.vue'
import RespondecoTopbar from '../topbar.vue'
import Component from 'vue-class-component'

import Vue from 'vue'
import { Injector } from '@/config/dependency-injection'
import { AuthenticationModule } from '@/authentication/store/authentication-module'
import { Account } from '@/api/generated'
import { isAdmin } from '@/shared/utils/user'
import { TokenHolder } from '@/shared/utils/token-holder'
import { AdminTokenHolder } from '@/config/injection-tokens'
import { AdministrationModule } from '@/business/administration/store/administration-module'
import HeaderUserBar from '@/main/header/header-user-bar.vue'
import ContactRespondeco from '@/main/header/contact-respondeco.vue'
import { isRespondeco } from '@/config/environments'

declare const $: any

@Component({
  components: {
    ContactRespondeco,
    HeaderUserBar,
    RespondecoMenu,
    RespondecoTopbar,
  },
  name: 'RespondecoHeader',
})
export default class Header extends Vue {
  public isRespondeco: boolean = isRespondeco()
  public toggled = false

  private adminModule = Injector.get(AdministrationModule)
  private authenticationModule = Injector.get(AuthenticationModule)
  private adminTokenHolder = Injector.get<TokenHolder>(AdminTokenHolder)

  get activeUser(): Account {
    return this.authenticationModule.authenticatedUser
  }

  get isAdmin(): boolean {
    return isAdmin(this.activeUser)
  }

  public isImpersonating(): boolean {
    return this.adminTokenHolder.get() !== undefined
  }

  public stopImpersonating() {
    this.adminModule.stopImpersonating()
  }
}
